module.exports = __webpack_public_path__ + "img/yijia4.a8ffcc57.jpg";